import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../config/FirebaseConfig.js";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../models/DataFunctions.js";
import addLogDocument from "./addLogDocument.js"; // Custom log function

// Utility function to get the temporary URL
const getTemporaryUrlV2 = async (file_id, token, prefix) => {
  const body = {
    file_id: file_id,
  };
  let url = prefix + `upload/refresh-presigned-url`;

  // Set up headers for the request
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
  try {
    let start = new Date();
    // Send POST request to the API
    const response = await fetch(url, {
      method: "POST",
      headers,
      body: JSON.stringify(body),
    });

    if (token === "vide") {
      return;
    }

    // Get the current Firebase user
    const auth = getAuthCentral();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      throw new Error("User not authenticated");
    }
    // Get the user's document reference from Firestore
    const db = getFirestore();
    let userRef = doc(db, "user", currentUser.uid);

    const userSnapshot = await getDoc(checkDB(userRef));

    let org_id = null;

    if (!userSnapshot.exists()) {
      return;
    }
    org_id = userSnapshot.get("org_id");
    // Check if the request was successful and handle the response once
    const responseText = await response.clone().text(); // Use clone() to preserve the response stream

    if (response.ok) {
      const responseData = await response.json(); // Assuming the API returns JSON
      let end = new Date();
      let time = end - start;
      // Log the request and response
      await addLogDocument(
        url,
        prefix,
        userRef,
        org_id,
        response.status.toString(),
        "",
        JSON.stringify(body), // Logs the request body
        responseText,
        "POST",
        time
      );
      return responseData?.url || null;
    } else {
      console.error(`Failed request: ${response.status}`);
      return `Failed request: ${response.status}`;
    }
  } catch (error) {
    console.error(`Exception occurred: ${error}`);
    return `Exception: ${error.message}`;
  }
};

export default getTemporaryUrlV2;
